import { 
  Typography, 
  Grid, 
  Card, 
  CardContent,
  Box,
  Divider
} from '@mui/material'
import {
  Inventory,
  PointOfSale,
  People,
  Settings,
  Pool,
  Assignment
} from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { LightspeedIcon, SkimmerIcon } from '../components/SystemIcons'
import { usePageTitle } from '../hooks/usePageTitle'

function Home() {
  usePageTitle('Home', '', true)
  const navigate = useNavigate()

  const cardStyle = {
    cursor: 'pointer',
    border: '2px solid',
    borderColor: 'secondary.light',
    transition: 'all 0.3s ease',
    '&:hover': {
      borderColor: 'secondary.main',
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 20px rgba(0, 127, 152, 0.15)',
    }
  }

  const disabledCardStyle = {
    ...cardStyle,
    cursor: 'not-allowed',
    opacity: 0.5,
    '&:hover': {
      transform: 'none',
      boxShadow: 'none',
      borderColor: 'secondary.light',
    }
  }

  return (
    <Box>
      <Grid container spacing={3}>
        {/* Lightspeed Tools Section */}
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: '10px' }}>
            <LightspeedIcon size={32} />
            <Typography variant="h5" sx={{ fontWeight: 700, textTransform: 'uppercase' }}>
              Lightspeed Tools
            </Typography>
          </Box>
          <Divider sx={{ mb: 3 }} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Card 
            sx={cardStyle}
            onClick={() => navigate('/lightspeed/products')}
          >
            <CardContent sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              py: 4
            }}>
              <Inventory sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />
              <Typography variant="h6" sx={{ textAlign: 'center' }}>
                Products Export
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={cardStyle}
            onClick={() => navigate('/lightspeed/sales')}
          >
            <CardContent sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              py: 4
            }}>
              <PointOfSale sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />
              <Typography variant="h6" sx={{ textAlign: 'center' }}>
                Sales Export
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={cardStyle}
            onClick={() => navigate('/lightspeed/customers')}
          >
            <CardContent sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              py: 4
            }}>
              <People sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />
              <Typography variant="h6" sx={{ textAlign: 'center' }}>
                Customers Export
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={cardStyle}
            onClick={() => navigate('/lightspeed/retailer-setup')}
          >
            <CardContent sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              py: 4
            }}>
              <Settings sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />
              <Typography variant="h6" sx={{ textAlign: 'center' }}>
                Retailer Setup Export
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Skimmer Tools Section */}
        <Grid item xs={12} sx={{ mt: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: '10px' }}>
            <SkimmerIcon size={32} />
            <Typography variant="h5" sx={{ fontWeight: 700, textTransform: 'uppercase' }}>
              Skimmer Tools
            </Typography>
          </Box>
          <Divider sx={{ mb: 3 }} />
        </Grid>

        {/* Skimmer placeholder cards */}
        <Grid item xs={12} md={6}>
          <Card sx={disabledCardStyle}>
            <CardContent sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              py: 4
            }}>
              <Pool sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />
              <Typography variant="h6" sx={{ textAlign: 'center' }}>
                Service Locations Export
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={disabledCardStyle}>
            <CardContent sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              py: 4
            }}>
              <Assignment sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />
              <Typography variant="h6" sx={{ textAlign: 'center' }}>
                Work Orders Export
              </Typography>
            </CardContent>
          </Card>
        </Grid>

      </Grid>
    </Box>
  )
}

export default Home